module.exports = __webpack_public_path__ + "4f361ac2c27edb9568df420cd31f7752.png";